import CancellationPageContainer from './CancellationPageContainer';

export default CancellationPageContainer;



// WEBPACK FOOTER //
// ./src/components/pages/Appointment/CancellationPage/index.js